import PublicContentBase from '../../ContentBase'
import './Styles.scss'

const PublicContentK33 = (): JSX.Element => {
    return <PublicContentBase />
}

export default PublicContentK33
